"use client";
import {NeoButton} from "@/components/forms";
import {useAllVehicleContext} from "@/context/live/allvehicle.context";
import {useLiveContext} from "@/context/live/live.context";
import {useNeoContext} from "@/context/neo/neo.context";
import {LiveFilterConfig} from "@/data";
import {Button, Image} from "@nextui-org/react";
import {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import Select from "react-select";
/**
 * TODO: @selva,@surya,@arun
 * Create a Validation Schema if you have a form & inject them
 */
export const LiveFilter: React.FC<LiveFilterProps> = ({onSubmit}) => {
  const {register, handleSubmit, setValue, control} = useForm();
  const data = LiveFilterConfig;

  const {vehicles, operators} = useNeoContext();
  const {tabVehicles} = useAllVehicleContext();
  const {filterValues} = useLiveContext();
  const [defaultSelectedKeys, setDefaultSelectedKeys] = useState<string[]>([]);

  const handleOnSubmit = (event: any) => {
    onSubmit!(event);
  };
  useEffect(() => {
    const vehicleList =
      tabVehicles?.map(x => ({
        label: x.name,
        value: x?.name
      })) || [];

    // const driverList =
    //   operators
    //     ?.map(x => {
    //       if (x.drivers.length > 0) {
    //         return x.drivers; // Flatten the drivers array
    //       }
    //       return [];
    //     })
    //     .map((x: any) => ({
    //       label: x?.name,
    //       value: x?.driverId?.toString()
    //     })) || [];
    data.vehicle = vehicleList;
    data.Driver = [];
  }, [data, tabVehicles]);
  const calculateDefaultSelectedKeys = (): string[] => {
    if (filterValues?.vehicleId && filterValues?.vehicleId !== undefined) {
      const filteredNames = filterValues.vehicleId as string;
      if (Array.isArray(filteredNames)) {
        return filteredNames;
      } else if (filterValues.vehicleId.length > 0 && filteredNames !== "") {
        return filteredNames.split(",");
      }
      return [];
    } else {
      return [];
    }
  };

  const clearvehicleFilters = () => {
    // console.log("clearvehicleFilters");
    // setFilterValues(prev => ({
    //   ...prev,
    //   vehicleId: []
    // }));
    onSubmit!({vehicle: []});
  };
  return (
    <>
      <form
        onSubmit={handleSubmit(event => {
          handleOnSubmit(event);
        })}
      >
        <div className="flex w-[350px] flex-col gap-5 p-4">
          {/* <NeoSelect
            {...register("vehicle")}
            label="Vehiclee"
            placeholder="Select Vehicle"
            labelPlacement="outside"
            selectionMode="multiple"
            defaultSelectedKeys={calculateDefaultSelectedKeys()}
          >
            {data?.vehicle?.map(item => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </NeoSelect> */}
          <Controller
            control={control}
            name="vehicle"
            defaultValue={calculateDefaultSelectedKeys()}
            render={({field}) => {
              const selectedOptions = data?.vehicle?.filter(opt =>
                field.value?.includes(opt.value)
              );

              const handleChange = (selected: any) => {
                field.onChange(selected.map((item: any) => item.value));
              };

              const handleSelectAll = () => {
                field.onChange(data?.vehicle?.map(opt => opt.value));
              };

              const handleDeselectAll = () => {
                field.onChange([]);
              };

              return (
                <div className="flex flex-col gap-2 rounded-2xl border border-gray-300 p-4">
                  <div className="m-2 mb-1 flex justify-between">
                    Vehicle
                    <div className="flex gap-2">
                      <Button
                        size="sm"
                        className="border border-gray-300 bg-[#fafafb] text-gray-700 hover:bg-gray-200"
                        onPress={handleSelectAll}
                      >
                        Select All
                      </Button>
                      <Button
                        size="sm"
                        onPress={handleDeselectAll}
                        className="border border-gray-300 bg-[#fafafb] text-gray-700 hover:bg-gray-200"
                      >
                        Deselect All
                      </Button>
                    </div>
                  </div>
                  <Select
                    isMulti
                    options={data?.vehicle || []}
                    value={selectedOptions}
                    onChange={handleChange}
                    placeholder="Select vehicle(s)..."
                    classNamePrefix="react-select"
                    closeMenuOnSelect={false}
                    isClearable={false}
                    //backspaceRemovesValue={true} // its used to remove the selected value on backspace
                    //  closeMenuOnScroll={false}
                    styles={{
                      control: (base: any) => ({
                        ...base,
                        minHeight: "40px",
                        borderColor: "#d4d4d8",
                        boxShadow: "none",
                        "&:hover": {
                          borderColor: "#d4d4d8"
                        }
                      }),
                      valueContainer: (base: any) => ({
                        ...base,
                        maxHeight: "100px",
                        overflowY: "auto",
                        flexWrap: "wrap"
                      }),
                      multiValue: (base: any) => ({
                        ...base,
                        backgroundColor: "white",
                        border: "1px solid #d4d4d8",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }),
                      multiValueLabel: (base: any) => ({
                        ...base,
                        color: "#131313"
                      }),
                      multiValueRemove: (base: any) => ({
                        ...base,
                        color: "#131313",
                        ":hover": {
                          backgroundColor: "#d4d4d8",
                          color: "#131313"
                        }
                      }),
                      option: (base: any, state: any) => ({
                        ...base,
                        backgroundColor: state.isFocused ? "#d4d4d8" : "white",
                        color: "#000",
                        cursor: "pointer"
                      })
                    }}
                  />
                </div>
              );
            }}
          />

          {/* <NeoSelect
            {...register("driver")}
            label="Driver"
            placeholder="Select Driver"
            labelPlacement="outside"
            selectionMode="multiple"
          >
            {data?.Driver?.map(item => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </NeoSelect> */}
          <div className="w-100 flex justify-end gap-5">
            <NeoButton
              type="submit"
              color="yellow"
              size="sm"
              className="gap-[5px] text-lg"
              startContent={
                <Image
                  className="h-5 w-5"
                  src="/icons/filter.svg"
                  alt="filter"
                />
              }
            >
              Filter
            </NeoButton>
            <NeoButton
              color="red"
              className="gap-[5px] text-lg"
              onClick={clearvehicleFilters}
              size="sm"
              // startContent={
              //   <Image
              //     className="h-5 w-5"
              //     src="/icons/filter.svg"
              //     alt="filter"
              //   />
              // }
            >
              Clear
            </NeoButton>
          </div>
        </div>
      </form>
    </>
  );
};
